import { CommonEnums } from 'src/app/shared/common.enums';

export class Lkup_Inst {
    public lkup_Inst: string;
    public lkup_Inst_Id: number;
    public dxMp_Id: number;
    public nm: string;
    public description: string;
    public lkupFltrCnd: string;
    public lkupFltrCndValid_Cd: string;
    public ver: string;
    public valid_Cd: string;
    public persistFlg: string;
    public primObjId: number;
    public updateBy: string;
    public lastUpdateBy: string;
    public updateDt: Date;
    public gen_Tab_Valid_Cd: string;
    public attr_Tab_Valid_Cd: string;
    public prop_Tab_Valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.lkup_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.lkupFltrCnd = CommonEnums.defaults.STRING_EMPTY;
        this.lkupFltrCndValid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
        this.valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.persistFlg = CommonEnums.defaults.SUCCESS_CODE;
        this.primObjId = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.gen_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.prop_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
    }

    static parse(lkup_InstTmp: Lkup_Inst): Lkup_Inst {
        let lkup_Inst: Lkup_Inst = new Lkup_Inst();
        lkup_Inst.copyFrom(lkup_InstTmp);
        return lkup_Inst;
    }
    
    getPrimaryKey():string{
        return this.lkup_Inst_Id +'.'+this.dxMp_Id;
    }

    copy(): Lkup_Inst {
        let lkup_InstTmp: Lkup_Inst = new Lkup_Inst();

        lkup_InstTmp.lkup_Inst_Id = this.lkup_Inst_Id;
        lkup_InstTmp.dxMp_Id = this.dxMp_Id;
        lkup_InstTmp.nm = this.nm;
        lkup_InstTmp.description = this.description;
        lkup_InstTmp.lkupFltrCnd = this.lkupFltrCnd;
        lkup_InstTmp.lkupFltrCndValid_Cd = this.lkupFltrCndValid_Cd;
        lkup_InstTmp.ver = this.ver;
        lkup_InstTmp.valid_Cd = this.valid_Cd;
        lkup_InstTmp.persistFlg = this.persistFlg;
        lkup_InstTmp.primObjId = this.primObjId;
        lkup_InstTmp.updateBy = this.updateBy;
        lkup_InstTmp.lastUpdateBy = this.lastUpdateBy;
        lkup_InstTmp.updateDt = this.updateDt;
        lkup_InstTmp.gen_Tab_Valid_Cd = this.gen_Tab_Valid_Cd;
        lkup_InstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd;
        lkup_InstTmp.prop_Tab_Valid_Cd = this.prop_Tab_Valid_Cd;

        return lkup_InstTmp;
    }

    copyFrom(lkup_InstTmp: Lkup_Inst): void {
        this.lkup_Inst_Id = lkup_InstTmp.lkup_Inst_Id;
        this.dxMp_Id = lkup_InstTmp.dxMp_Id;
        this.nm = lkup_InstTmp.nm;
        this.description = lkup_InstTmp.description;
        this.lkupFltrCnd = lkup_InstTmp.lkupFltrCnd;
        this.lkupFltrCndValid_Cd = lkup_InstTmp.lkupFltrCndValid_Cd;
        this.ver = lkup_InstTmp.ver;
        this.valid_Cd = lkup_InstTmp.valid_Cd;
        this.persistFlg = lkup_InstTmp.persistFlg;
        this.primObjId = lkup_InstTmp.primObjId;
        this.updateBy = lkup_InstTmp.updateBy;
        this.lastUpdateBy = lkup_InstTmp.lastUpdateBy;
        this.updateDt = lkup_InstTmp.updateDt;
        this.gen_Tab_Valid_Cd = lkup_InstTmp.gen_Tab_Valid_Cd;
        this.attr_Tab_Valid_Cd = lkup_InstTmp.attr_Tab_Valid_Cd;
        this.prop_Tab_Valid_Cd = lkup_InstTmp.prop_Tab_Valid_Cd;
    }

    compare(lkup_InstTmp: Lkup_Inst): string {
        let lkup_InstString: string = this.toString(false);
        let lkup_InstTmpString: string = lkup_InstTmp.toString(false);

        if (lkup_InstString != lkup_InstTmpString) {
            return lkup_InstString + ', ' + lkup_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str:string= "Lkup_Inst [lkup_Inst=" + this.lkup_Inst + ",lkup_Inst_Id="+ this.lkup_Inst_Id+", dxMp_Id=" + this.dxMp_Id + ", nm=" + this.nm +
            ", description=" + this.description + ", lkupFltrCnd=" + this.lkupFltrCnd +
            ", lkupFltrCndValid_Cd=" + this.lkupFltrCndValid_Cd + ", ver=" + this.ver + ", valid_Cd=" + this.valid_Cd +
            ", persistFlg=" + this.persistFlg + ", primObjId=" + this.primObjId + ", updateBy=" + this.updateBy +
            ", updateDt=" + this.updateDt + ", gen_Tab_Valid_Cd=" + this.gen_Tab_Valid_Cd +
            ", attr_Tab_Valid_Cd=" + this.attr_Tab_Valid_Cd + ", prop_Tab_Valid_Cd=" + this.prop_Tab_Valid_Cd ;

            if (isNotCompare) {
                str+= ", lastUpdateBy=" + this.lastUpdateBy;
            }
    
            str += ']';
    
            return str;
        }
    }	